
import { useQuery } from '@tanstack/react-query';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
const { get } = erpApi(); 
export interface MotivoDetalle {
  id_observacion: string;
  nombre_observacion: string;
}

export interface ObservacionContratoHistorial {
  id_contrato_observacion: string;
  codigo: string;
  fecha_observacionContrato: string;
  descripcion_observacion: string;
  contrato: string;
  motivos_detallados: Record<string, MotivoDetalle[]>;
  responsables: string[];
}



export const useGetObservacionesPorContrato = (
  contractId?: string,
  enabled = false
) => {
  return useQuery({
    queryKey: ['historial-observaciones-contrato', contractId],
    queryFn: async () => {
      if (!contractId) return [];
    
      const response = await get<any>(
        `${urlBackend}api/v1/contrato/${contractId}/observaciones/todas/`,
        true
      );
      const res = response;


      if (Array.isArray(res)) {
        return res;
      }

      if (res?.data && Array.isArray(res.data)) {
        return res.data;
      }

      return [];

      
    },
    enabled: enabled && !!contractId,
  });
};